import React from 'react'
import { useStore, companyStoreId } from 'stores'
import { useI18next } from 'gatsby-plugin-react-i18next'
import { getPathWithoutLocale } from 'libs/router/routeHelper'
import { languages } from 'assets/languages'

const CreateCompanyRedirection = ({ children, location }) => {
  const { navigate } = useI18next()
  const companyStore = useStore(companyStoreId)

  React.useEffect(() => {
    const { pathname } = location
    const path = getPathWithoutLocale(pathname, languages)
    
    const createProfilePath = '/company-profile/create/'
    if (!path.includes(createProfilePath) &&
      companyStore.getters.isProfileReady() &&
      !companyStore.getters.getCompanyProfile()) {
      navigate(createProfilePath)
    }
  }, [companyStore.getters.isProfileReady()])

  return (
    <>
      {children}
    </>
  )
}

export default CreateCompanyRedirection